<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Histórico do cliente</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Histórico</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Nome cliente</th>
                    <th scope="col" class="border-0 text-left">Nome usuário</th>
                    <th scope="col" class="border-0">Data da alteração</th>
                    <th scope="col" class="border-0">Método de pagamento</th>
                    <th scope="col" class="border-0">Taxa</th>
                    <th class="text-center">Parcela inicial</th>
                    <th class="text-center">Parcela final</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(merchantHistory, idxHistory) in merchantHistories"
                  >
                    <template
                      v-if="HasMerchantPaymentMethodHistories(merchantHistory)"
                    >
                      <tr
                        v-for="(tax, idxTax) in merchantHistory
                          .MerchantPaymentMethodHistories[0]
                          .MerchantPaymentMethodTaxHistories"
                        :key="'tr' + idxHistory + idxTax"
                      >
                        <td></td>
                        <td class="text-left">{{ merchantHistory.Name }}</td>
                        <td class="text-left">
                          {{ merchantHistory.UserInternal.Name }}
                        </td>
                        <td>{{ merchantHistory.ChangedDate | date }}</td>
                        <td>{{ merchantHistory.PaymentMethod.Name }}</td>
                        <td :key="`taxA-${idxHistory}${idxTax}`">
                          {{ tax.Amount }}
                        </td>
                        <td :key="`taxI-${idxHistory}${idxTax}`">
                          {{ tax.InitialInstallment }}
                        </td>
                        <td :key="`taxE-${idxHistory}${idxTax}`">
                          {{ tax.EndInstallment }}
                        </td>
                        <td :key="`taxS-${idxHistory}${idxTax}`">
                          {{ tax.Status }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr :key="'tr' + idxHistory">
                        <td></td>
                        <td class="text-left">{{ merchantHistory.Name }}</td>
                        <td class="text-left">
                          {{ merchantHistory.UserInternal.Name }}
                        </td>
                        <td>{{ merchantHistory.ChangedDate | date }}</td>
                        <td>{{ merchantHistory.PaymentMethod.Name }}</td>
                        <td
                          v-if="
                            HasOneMerchantPaymentMethodHistories(
                              merchantHistory
                            )
                          "
                          :key="`taxA-${idxHistory}`"
                        >
                          {{
                            merchantHistory.MerchantPaymentMethodHistories[0]
                              .MerchantPaymentMethodTaxHistories[0].Amount
                          }}
                        </td>
                        <td v-else></td>
                        <td
                          v-if="
                            HasOneMerchantPaymentMethodHistories(
                              merchantHistory
                            )
                          "
                          class="text-center"
                          :key="`taxI-${idxHistory}`"
                        >
                          {{
                            merchantHistory.MerchantPaymentMethodHistories[0]
                              .MerchantPaymentMethodTaxHistories[0]
                              .InitialInstallment
                          }}
                        </td>
                        <td v-else></td>
                        <td
                          v-if="
                            HasOneMerchantPaymentMethodHistories(
                              merchantHistory
                            )
                          "
                          class="text-center"
                          :key="`taxE-${idxHistory}`"
                        >
                          {{
                            merchantHistory.MerchantPaymentMethodHistories[0]
                              .MerchantPaymentMethodTaxHistories[0]
                              .EndInstallment
                          }}
                        </td>
                        <td v-else></td>
                        <td
                          v-if="
                            HasOneMerchantPaymentMethodHistories(
                              merchantHistory
                            )
                          "
                          :key="`taxS-${idxHistory}`"
                        >
                          {{
                            merchantHistory.MerchantPaymentMethodHistories[0]
                              .MerchantPaymentMethodTaxHistories[0].Status
                          }}
                        </td>
                        <td v-else></td>
                        <td></td>
                      </tr>
                    </template>
                  </template>
                  <tr
                    v-if="
                      merchantHistories == undefined ||
                      merchantHistories == null ||
                      merchantHistories.length == 0
                    "
                  >
                    <td colspan="10">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome usuário"
            type="text"
            class="form-control"
            v-model="filter.NameUserInternal"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePaymentMethod" :value="null">
            <option :value="null" selected>Método de pagamento</option>
            <option
              v-for="type in paymentMethods"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field
            placeholder="Data da alteração"
            v-model="filter.ChangedDate"
          ></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Status"
            type="text"
            class="form-control"
            v-model="filter.Status"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "merchant-history",
  components: {
    dateField,
  },
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        NameUserInternal: null,
        ChangedDate: null,
        Status: null,
        CodePaymentMethod: null,
      },
      idMerchant: null,
      merchantHistories: [],
      paymentMethods: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantHistory(this.idMerchant);
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantHistory(this.idMerchant);
    },
  },
  mounted() {
    this.idMerchant = this.$route.params.idMerchant;
    this.ListMerchantHistory(this.idMerchant);
    this.$store
      .dispatch("ListPaymentMethod")
      .then((response) => {
        this.paymentMethods = response;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista de métodos de pagamento",
          error
        );
      });
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantHistory(this.idMerchant);
    },
    ListMerchantHistory: function (id) {
      this.countFilter = 0;
      if (hasValue(this.filter.NameUserInternal)) this.countFilter++;
      if (hasValue(this.filter.ChangedDate)) this.countFilter++;
      if (hasValue(this.filter.Status)) this.countFilter++;
      if (hasValue(this.filter.CodePaymentMethod)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": id,
        "Object.UserInternal.Name": this.filter.NameUserInternal,
        "Object.ChangedDate": this.filter.ChangedDate,
        "Object.MerchantPaymentMethodHistories[0].MerchantPaymentMethodTaxHistories[0].Status": this
          .filter.Status,
        "Object.PaymentMethod.Code": this.filter.CodePaymentMethod,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantHistory", { params: data })
        .then((response) => {
          this.merchantHistories = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar o histórico do cliente",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        NameUserInternal: null,
        ChangedDate: null,
        Status: null,
        CodePaymentMethod: null,
      };
      this.ListMerchantHistory(this.idMerchant);
    },
    HasOneMerchantPaymentMethodHistories: function (merchantHistory) {
      return (
        merchantHistory.MerchantPaymentMethodHistories != null &&
        merchantHistory.MerchantPaymentMethodHistories != undefined &&
        merchantHistory.MerchantPaymentMethodHistories.length == 1
      );
    },
    HasMerchantPaymentMethodHistories: function (merchantHistory) {
      return (
        merchantHistory.MerchantPaymentMethodHistories != null &&
        merchantHistory.MerchantPaymentMethodHistories != undefined &&
        merchantHistory.MerchantPaymentMethodHistories.length > 1
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/merchantHistory.vue